import { message } from 'antd'

import { changeLanguage as apiChangeLang } from 'utils/apis'
import { setInits, startLoading, stopLoading } from 'app-redux/inits/actions'

// Dipisah dari actions.js karena ada circular dependency
export const changeLanguage = (payload) => {
  return (dispatch) => {
    dispatch(startLoading())
    return apiChangeLang(payload.value)
      .then((response) => {
        if (response.data.success) {
          message.success(response.data.message)
          const { data } = response.data
          dispatch(setInits(data.init))
        } else {
          message.error(response.data.message)
        }
        dispatch(stopLoading())
        return response
      })
      .catch(() => {
        message.error('Error:: Cannot update language!')
        dispatch(stopLoading())
      })
  }
}
